<div *ngIf="biometry">
   <div *ngIf="!verifyPressure && !deviceAllowed && !mobile" class="info advise" id="messageContainer">
      <mat-icon class="icon help">help</mat-icon>
      <p class="mb-0">{{'finish_sigbio_custom_01' | translate:_transParam}}</p>
   </div>
   <div *ngIf="verifyPressure && !deviceAllowed && !mobile" class="info warn">
      <mat-icon class="icon cancel">cancel</mat-icon>
      <p class="mb-0">{{'finish_sigbio_custom_02' | translate:_transParam}}</p>
   </div>
</div>
<div class="container" id="container">
   <div class="containerQR" id="containerQR" *ngIf="!mobile && routeQR !== ''">
      <p class="title">{{'firma_desde_movil' | translate}}</p>
      <mat-divider></mat-divider>
      <p class="subtitle">{{'escanea_qr' | translate}}</p>
      <ngx-qrcode
      [elementType]="elementType"
      [errorCorrectionLevel]="correctionLevel"
      [value]="routeQR"
      cssClass="bshadow"></ngx-qrcode>
      <P class="description">{{'escanea_qr_descripcion' | translate}}</P>
   </div>
   <div>
      <app-ivpad [ngClass]="{isDisabled: verifyPressure && !deviceAllowed}" #ivpad [startOpened]="true" [opened]="true" [isModal]="true" [showButtons]="false"
            [signingEnabled]="false"(save)="submit($event?.content, true)" (onRequestReady)="signPDF($event)" cdkFocusInitial>
      </app-ivpad>
      <div class="save-new-signature-class" *ngIf="saveSignatureUser">
         <mat-checkbox id="saveNewSignature" [(ngModel)]="checked">{{'save_new_signature_label' | translate:_transParam}}</mat-checkbox>
      </div>
   </div>
</div>
